module.exports = __webpack_public_path__ + "static/media/ow2ll25.9ecc95ce.png";